import React from "react";
import nyclogo from "../assets/NYC-logo.png";
import LanguageSwitcher from "./LanguageSwitcher";

// Header with both text and logo
const Header = () => {
  return (
    <header className="relative border-b-2 bg-white border-border shadow-sm px-4 sm:px-6 py-3">
      <img
        src={nyclogo}
        alt="New York City Public Schools"
        className="h-auto w-28 sm:w-32 mx-auto sm:absolute sm:left-6 sm:top-1/2 sm:-translate-y-1/2"
      />

      <p className="hidden sm:block text-center font-semibold text-sm pl-16">
        Your answers will be used to provide careers that might interest you
      </p>

      <LanguageSwitcher className="absolute right-4 sm:right-6 top-1/2 -translate-y-1/2" />
    </header>
  );
};

// Header with logo only
export const LogoHeader = () => {
  return (
    <header className="px-4 py-2 flex h-34 items-center justify-end gap-4">
      <LanguageSwitcher />
      <img src={nyclogo} alt="New York City Public Schools" />
    </header>
  );
};

export default Header;
